export default __webpack_public_path__ + "static/bb-logo-e87e0afb5a8f5499005ae0227b6f2e81.png";